export default {
  milk_analysis:[]
}